// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"42a22e1f","707":"381f8b96","729":"3c5435db"}[chunkId] + ".js";
};